import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "height-full details-container" }
const _hoisted_2 = { class: "mb-2 header d-flex align-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ml-2 title text-h5 font-weight-medium" }
const _hoisted_5 = { class: "text-subtitle" }
const _hoisted_6 = { class: "mt-4 mb-5" }
const _hoisted_7 = { class: "details-content" }
const _hoisted_8 = { class: "mt-4 d-flex width-full justify-space-between" }

import { withDefaults, computed } from 'vue'
import stepTemplates from '../Step'
import StepType from '@/lib/enums/StepType'
import GoalDetail from './DetailTypes/Goal.vue'
import TriggerDetail from './DetailTypes/Trigger.vue'
import WaitDetail from './DetailTypes/Wait.vue'
import EmailDetail from './DetailTypes/Email.vue'
import SubscribeDetail from './DetailTypes/Subscribe.vue'
import ConditionDetail from './DetailTypes/Condition.vue'
import { useForm } from 'vee-validate'
import { DfNode, DfNodeData } from '@/interfaces/drawflow'
import { IStepData } from '@/interfaces/hoppermation'

interface IProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submit?: (id: number, details: any) => void
  cancel?: () => void
  node?: DfNode
}


export default /*#__PURE__*/_defineComponent({
  props: {
    submit: { type: Function, required: false, default: () => ({}) },
    cancel: { type: Function, required: false, default: () => ({}) },
    node: { type: null, required: false, default: () => ({} as DfNode) }
  },
  setup(__props: any) {

const props = __props as { submit: (id: number, details: any) => void, cancel: () => void, node: DfNode }


const nodeData = { ...props.node.data } as DfNodeData
const { validate } = useForm()

const icon = computed((): string => {
  return stepTemplates[props.node.name].icon
})

const isTriggerStep = computed((): boolean => {
  return props.node.name === StepType.TRIGGER
})

const isGoalStep = computed((): boolean => {
  return props.node.name === StepType.GOAL
})

const isWaitStep = computed((): boolean => {
  return props.node.name === StepType.WAIT
})

const isEmailStep = computed((): boolean => {
  return props.node.name === StepType.EMAIL
})

const isSubscribeStep = computed((): boolean => {
  return props.node.name === StepType.SUBSCRIBE
})

const isConditionStep = computed((): boolean => {
  return props.node.name === StepType.CONDITION
})

const updateNodeData = (data: IStepData): void => {
  Object.keys(data).forEach((value) => {
    nodeData[value as keyof IStepData] = data[value as keyof IStepData]
  })
}

const submitDetails = async (): Promise<void> => {
  if (nodeData) {
    const parsedDetails = JSON.parse(JSON.stringify(nodeData))
    const valid = await validate()
    // TODO vuetify 3 validation, remove as soon as available
    // validates children fields, which have already been validated, therefore it's' invalid
    if ('url' in valid.errors && 'templateKey' in valid.errors) {
      valid.valid = true
    }
    if (valid.valid) {
      props.submit(props.node.id, parsedDetails)
    }
  }
}

const cancelDetails = async (): Promise<void> => {
  props.cancel()
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(icon),
        height: "32"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(`details.${props.node.name.toLowerCase()}.title`)), 1)
    ]),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(`details.${props.node.name.toLowerCase()}.desc`)), 1),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_v_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "row-max" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: _unref(nodeData).stepName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(nodeData).stepName = $event)),
                    "persistent-hint": "",
                    label: _ctx.$t('details.stepName.placeholder'),
                    hint: _ctx.$t('details.stepName.hint'),
                    class: "mb-0"
                  }, null, 8, ["modelValue", "label", "hint"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_unref(isTriggerStep))
        ? (_openBlock(), _createBlock(TriggerDetail, {
            key: 0,
            details: props.node.data,
            "update-node-data": updateNodeData
          }, null, 8, ["details"]))
        : _createCommentVNode("", true),
      (_unref(isGoalStep))
        ? (_openBlock(), _createBlock(GoalDetail, {
            key: 1,
            details: props.node.data,
            "update-node-data": updateNodeData
          }, null, 8, ["details"]))
        : _createCommentVNode("", true),
      (_unref(isWaitStep))
        ? (_openBlock(), _createBlock(WaitDetail, {
            key: 2,
            details: props.node.data,
            "update-node-data": updateNodeData
          }, null, 8, ["details"]))
        : _createCommentVNode("", true),
      (_unref(isEmailStep))
        ? (_openBlock(), _createBlock(EmailDetail, {
            key: 3,
            details: props.node.data,
            "update-node-data": updateNodeData
          }, null, 8, ["details"]))
        : _createCommentVNode("", true),
      (_unref(isSubscribeStep))
        ? (_openBlock(), _createBlock(SubscribeDetail, {
            key: 4,
            details: props.node.data,
            "update-node-data": updateNodeData
          }, null, 8, ["details"]))
        : _createCommentVNode("", true),
      (_unref(isConditionStep))
        ? (_openBlock(), _createBlock(ConditionDetail, {
            key: 5,
            details: props.node.data,
            "update-node-data": updateNodeData
          }, null, 8, ["details"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_v_btn, {
        class: "text-disabledText details-action",
        color: "disabled",
        text: "",
        onClick: cancelDetails
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('actions.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        color: "primary",
        type: "submit",
        class: "details-action",
        text: "",
        onClick: submitDetails
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('actions.confirm')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})